var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row"},[_c('v-select',{staticClass:"pt-0 ps-4",attrs:{"label":_vm.$t('sort'),"solo":"","flat":"","dense":"","items":_vm.sortOptions,"hide-details":""},on:{"change":_vm.handleSortFilter},model:{value:(_vm.sortFilter),callback:function ($$v) {_vm.sortFilter=$$v},expression:"sortFilter"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }